import { apiConnector } from "../apiConnection";
import {
  loginEndpoint,
  sendOtpEndpoint,
  signUpEndpoints,
  updatePasswordEndpoint,
  verifyOtpEndpoint,
} from "../apiEndpoints";
import toast from "react-hot-toast";

// export const loginApi = async (email,password) =>{
//     try {
//
//         const bodyData={
//             email,password
//         }
//         const request = {
//             url:loginEndpoint.url,
//             method:loginEndpoint.method,
//             bodyData,
//             withCredentials: true,
//         }
//
//         toast.loading("Logging you in");
//         const {data} = await apiConnector(request);
//         toast.dismiss()
//         toast.success("Logged in successfudilly")
//
//         return data;
//     } catch (error) {
//         toast.dismiss()
//         toast.error("Could not log you in")
//        console.error(error);
//     }
// }
export const loginApi = async (email, password) => {
  try {
    const bodyData = {
      email,
      password,
    };
    const request = {
      method: loginEndpoint.method,
      url: loginEndpoint.url,
      bodyData: bodyData,
      withCredentials: loginEndpoint.withCredentials,
    };
    toast.loading("Logging you in");
    const response = await apiConnector(request);

    toast.dismiss();
    if (response.status !== 200)
      throw new Error(response.data.message || "error occured!");

    localStorage.removeItem("token");
    localStorage.setItem("token", `${response.data.token}`);
    localStorage.setItem("user", `${response.data.name}`);
    toast.success("User logged in");
    window.location.href = "/";
    return response.data;
  } catch (error) {
    toast.dismiss();
    toast.error(error.message);
  }
};
export const signupApi = async (
  name,
  email,
  password,
  phone,
  gender,
  genderPreference
) => {
  try {
    const bodyData = {
      name,
      email,
      password,
      phone: parseInt(phone),
      gender,
      genderPreference,
    };
    const request = {
      url: signUpEndpoints.url,
      method: signUpEndpoints.method,
      bodyData,
      withCredentials: signUpEndpoints.withCredentials,
    };
    toast.loading("Signing you up");
    const response = await apiConnector(request);
    if (response.status !== 201)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    toast.success("User registered successfully");
    toast.dismiss();
    return true;
  } catch (error) {
    toast.dismiss();
    toast.error("Could not register user");
    return false;
  }
};

export const sendOtpApi = async (email) => {
  try {
    const bodyData = {
      email,
    };
    const request = {
      url: sendOtpEndpoint.url,
      method: sendOtpEndpoint.method,
      bodyData,
      withCredentials: sendOtpEndpoint.withCredentials,
    };
    toast.loading("Sending OTP");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    toast.success("Sent OTP");
    return true;
  } catch (error) {
    toast.dismiss();
    toast.error("Couldn't send OTP");
    return false;
  }
};

export const verifyOtpApi = async (email, otp) => {
  try {
    const bodyData = {
      email,
      otp: parseInt(otp),
    };
    const request = {
      url: verifyOtpEndpoint.url,
      method: verifyOtpEndpoint.method,
      bodyData,
      withCredentials: verifyOtpEndpoint.withCredentials,
    };
    toast.loading("Verifying OTP");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    toast.success("OTP Verified");
    return response.data.token;
  } catch (error) {
    toast.dismiss();
    toast.error("Couldn't verify OTP");
    return null;
  }
};

export const updatePasswordApi = async (email, token, password) => {
  try {
    const bodyData = { email, token, newPassword: password };
    const request = {
      url: updatePasswordEndpoint.url,
      method: updatePasswordEndpoint.method,
      bodyData,
      withCredentials: updatePasswordEndpoint.withCredentials,
    };
    toast.loading("Updating Password");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    toast.success("Password Updated");
    return true;
  } catch (error) {
    toast.dismiss();
    toast.error("Couldn't update password");
    return false;
  }
};
export const testAuth = async () => {
  const url = "https://carpool-backend-muj.onrender.com/api/auth/test-auth";
};
